import script from "./TextAreaInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./TextAreaInput.vue?vue&type=script&setup=true&lang=ts"

import "./TextAreaInput.vue?vue&type=style&index=0&id=72ac9a28&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72ac9a28"]])

export default __exports__